import classes from "./Tutorial.module.css"
import image01 from "../../assets/images/unlock_gear_01.png"
import image02 from "../../assets/images/unlock_gear_02.png"
import image03 from "../../assets/images/unlock_gear_03.png"
import image04 from "../../assets/images/unlock_gear_04.png"
import image05 from "../../assets/images/unlock_gear_05.png"
import tool_01 from "../../assets/images/tool_01.png"
import tool_02 from "../../assets/images/tool_02.png"
import tool_03 from "../../assets/images/tool_03.png"
import tool_04 from "../../assets/images/tool_04.png"
import tool_05 from "../../assets/images/tool_05.png"
import tool_06 from "../../assets/images/tool_06.png"
import tool_07 from "../../assets/images/tool_07.png"
import tool_08 from "../../assets/images/tool_08.png"
import finder_01 from "../../assets/images/seed_finder_01.png"
import finder_02 from "../../assets/images/seed_finder_02.png"
import lister_01 from "../../assets/images/seed_listing_01.png"
import fresh_gear from "../../assets/images/fresh_gear.png"
import getUnicodeFlagIcon from "country-flag-icons/unicode"
import React, { useState } from "react"
import Tabs from "./Tabs"
import { useTranslation } from "react-i18next"
import { NavLink } from "react-router-dom"
import { CopyBlock, dracula } from "react-code-blocks"
import lanista from "../../assets/images/lanista.jpg"

const Tutorial = props => {
    const [activeTab, setActiveTab] = useState(0)
    const { t } = useTranslation()

    const get_tutorial_page = () => {
        switch (activeTab) {
            case 0:
                return <ProfileTutorial />
            case 1:
                return <GearSeedTutorial />
            default:
                return <SeedListingTutorial />
        }
    }

    return (
        <>
            <h1>Splatoon 3 - {t("misc:Navigation.Tutorial")}</h1>
            <div className={classes.Content}>
                <strong>
                    Note: If you make videos about this tutorial, feel free to link them to me, so I can link them here.
                </strong>
            </div>
            <Tabs clicked={setActiveTab} active={activeTab} />
            {get_tutorial_page()}
        </>
    )
}

const ProfileTutorial = props => {
    return (
        <div className={classes.WrapperTop}>
            <h2>Introduction</h2>
            <p>
                This is a preliminary tutorial to explain the basics about the profile page and how to import data for
                the badge tracker. A more detailed version will be uploaded in the next days.
            </p>
            <h3>About</h3>
            <p>
                <NavLink to={"/profile"}>The profile page can be accessed here.</NavLink> It has 4 tabs:
            </p>
            <h4>Profile Settings</h4>
            <p>
                This page gives an overview of stuff you have unlocked that are relevant for the{" "}
                <NavLink to={"/seedlisting"}>SeedListing tab</NavLink>. You can set your level, unlocked items from the
                catalogue, unlocked titles and unlocked banners.
            </p>
            <h4>Badge Progress</h4>
            <p>
                This page gives an overview of your progress on certain badges. For now this is limited to badges that
                are obtained from Salmon Run or from public battles, as well as your level and the number of Jackpots
                you need for the badge.
            </p>
            <h4>Update Progress</h4>
            <p>
                This page allows you to update the progress for your badges that are battle and salmon run related. You
                have the option to upload results from SplatNet at the bottom of the page. Please check the next section
                on how to obtain said info.
            </p>
            <h4>Seeds</h4>
            <p>
                This page is only shown when you inputted your seed key. It gives an overview of all your current seeds.
            </p>
            <h2>Importing Data</h2>
            <p>
                Right now there are two ways to obtain progress for the badge tracker: reading your savegame (requires a
                moddable switch) or from SplatNet records.
            </p>
            <h3>SplatNet</h3>
            <p>
                Please note that this option requires you to regularly upload matches that are obtained from SplatNet.
                You can use <a href="https://github.com/frozenpandaman/s3s">s3s</a> to obtain said files. Please refer
                to the chapter{" "}
                <a href="https://github.com/frozenpandaman/s3s#setup-instructions-">Setup instructions</a> on how to use
                the tool.
            </p>
            <p>After the initial setup, you can run the following command to get your latest matches:</p>
            <CopyBlock
                language="bash"
                text={"python s3s.py -o"}
                theme={dracula}
                wrapLines={true}
                showLineNumbers={false}
                codeBlock
            />
            <p>
                This will create a folder called <code>exports</code>. This folder has two sub-folders,{" "}
                <code>coop_results</code> and <code>results</code>. The files inside these two sub-folders can be
                uploaded to update the badge tracker.
            </p>
            <h3>Savegame</h3>
            <p>
                For this method you need to extract your savegame (i.e. with JKSV). Join a discord server where you can
                DM Lanista (i.e. <a href="https://discord.gg/dgYZW4bqep">this one</a>). DM her the savegame with the
                command <code>!savegame</code>. This will return a database backup that you upload{" "}
                <NavLink to={"/settings"}>on the seetings page</NavLink>.
            </p>
            <img src={lanista} alt="lanista" />
        </div>
    )
}

const GearSeedTutorial = props => {
    return (
        <div className={classes.WrapperTop}>
            <strong>
                <p>Other Tutorials</p>
                <ul className={classes.ListElems}>
                    <li>
                        <a href="https://www.youtube.com/watch?v=MrY4le2tzcY">{getUnicodeFlagIcon("US")} by Keen</a>
                    </li>
                    <li>
                        <a href="https://note.com/gamewagashi/n/n2eab91b2c344">
                            {getUnicodeFlagIcon("JP")} by みずようかん
                        </a>
                    </li>
                    <li>
                        <a href="https://ikatimes.com/how-to-use-gear-seed-checker/">
                            {getUnicodeFlagIcon("JP")} by イカタイムズ
                        </a>
                    </li>
                    <li>
                        <a href="https://www.youtube.com/watch?v=qFUKuCwIO1Q">{getUnicodeFlagIcon("JP")} by りお</a>
                    </li>
                    <li>
                        <a href="https://www.bilibili.com/video/BV1Pe4y1L7s1">
                            {getUnicodeFlagIcon("CN")} by @purelu_7
                        </a>
                    </li>
                    <li>
                        <a href="https://leanny.github.io/tutorials/cn_by_zhongyuzhou820.png">
                            {getUnicodeFlagIcon("CN")} by @zhongyuzhou820
                        </a>
                    </li>
                    <li>
                        <a href="https://hackmd.io/@kXPlZ_-qRnSVCOAoKrJEBg/HkNyVtSGo">
                            {getUnicodeFlagIcon("CN")} by Xar Dent
                        </a>
                    </li>
                    <li>
                        <a href="https://www.bilibili.com/read/cv19799932">{getUnicodeFlagIcon("CN")} by NekoMawarii</a>
                    </li>
                    <li>
                        <a href="https://www.bilibili.com/read/cv18892539">{getUnicodeFlagIcon("CN")} by SLVRMN</a>
                    </li>
                    <li>
                        <a href="https://www.bilibili.com/video/BV1QY411o7er">
                            {getUnicodeFlagIcon("CN")} by 索隆大魔王
                        </a>
                    </li>
                    <li>
                        <a href="https://forum.gamer.com.tw/C.php?bsn=26487&snA=2223">
                            {getUnicodeFlagIcon("TW")} by KnucklesLee
                        </a>
                    </li>
                    <li>
                        <a href="https://www.youtube.com/watch?v=8ZMXUIifwPg&feature=youtu.be">
                            {getUnicodeFlagIcon("DE")} by DestinyCast
                        </a>
                    </li>
                </ul>
            </strong>
            <h2>About Gear Seed Checker</h2>
            <p>
                In Splatoon 3 every piece of gear has a seed. This seed determines every future roll of this specific
                gear, as well as if drink tickets take effect or not.
            </p>
            <h2>FAQ</h2>
            <ul>
                <li>
                    Q: Do I need a hacked switch for this?
                    <br />
                    A: No.
                </li>
                <li>
                    Q: Can I get banned for this?
                    <br />
                    A: No. All you do is to keep track of your ability rolls and then use a drink at some point that
                    coincidentally leads to your desired abilities. This is not trackable and therefore you cannot get
                    banned for this.
                </li>
                <li>
                    Q: Does this work with Salmon Run Gear?
                    <br />
                    A: Yes, but the pre-set abilities should not be included in your seed search.
                </li>
                <li>
                    Q: What happens when I replace the gear (i.e. SplatNet3)?
                    <br />
                    A: Nothing, the seed is unchanged.
                </li>
                <li>
                    Q: What happens when I use chunks?
                    <br />
                    A: Chunks do not change the seed, so you can just continue as usual.
                </li>
                <li>
                    Q: I did not keep track of one of my abilities. Do I need to start from 0 again?
                    <br />
                    A: No, in this case you can just leave the one slot at "None" and continue as usual.
                </li>
                <li>
                    Q: What exactly is slot 0?
                    <br />
                    A: Slot 0 is the time your start tracking your seed.
                </li>
            </ul>
            <h2>Importing Data from SplatNet</h2>
            <p>
                It is advised to import your gear from SplatNet. This will also give you the opportunity to have a lot
                faster seed finding. Follow the instructions on the User Settings page for the import step.
            </p>
            <h2>Getting the Seed</h2>
            <p>There are two scenarios for obtaining the seed:</p>
            <ul>
                <li>Fresh Gear</li>
                <li>Already Leveled Gear</li>
            </ul>
            <h3>Fresh Gear</h3>
            <p>
                This method only works when you imported your gear from SplatNet. If you have obtained a new piece of
                gear and did not level it yourself (it is okay for the gear to have abilities on it when it comes from
                Murch or Salmon Run), then click on the "Brand New Gear" button. It will automatically calculate your
                seed.
            </p>
            <p>
                <img src={fresh_gear} alt="fresh gear" />
            </p>
            <h3>Already Leveled Gear</h3>
            <p>
                Here you need to level up your gear. If you imported your gear from SplatNet, then you can select the
                piece of gear at the beginning and only require 3 to 4 slots on average. If you did not import your gear
                from SplatNet, then it requires you to have 9 to 10 slots on average.
            </p>
            <p>
                Move to the "Gear Seed Recovery" page in order to continue. If you have the gear in your Database, then
                select it first before continuing. If you have imported your gear from SplatNet in the past and obtained
                this gear later, then simply add it on the Gear Database page. It is not required to do a full SplatNet
                import again.
            </p>
            <h4>Level Up from Empty Slot</h4>
            <p>
                When you level your gear and unlock an empty slot, the new ability can be entered in the calculator. In
                the example here you notice that "Quick Super Jump" got unlocked.
            </p>
            <img src={image01} alt="unlock_gear_01" /> <img src={image02} alt="unlock_gear_02" />
            <p>
                Note: Using a drink requires you to set the drink as well. When you unlock an ability under the
                influence of a drink, then this symbol can be seen.
            </p>
            <img src={image03} alt="unlock_gear_03" width="256" />
            <h4>Level Up from Full Slot</h4>
            <p>Here you enter the ability that pops up at the end.</p>
            <img src={image05} alt="unlock_gear_05" width="256" />
            <h4>From Snail Rerolls</h4>
            <p>
                Rerolling gives you 3 abilities at once. Enter them with NO Drink effect and from left to right in the
                calculator.
            </p>
            <img src={image04} alt="unlock_gear_04" width="256" />
            <h4>Example (With SplatNet import)</h4>
            <p>
                For this example I use the Takoroka Mesh. I already leveled the gear a bit and scrubbed it for a fresh
                start.
            </p>
            <img src={tool_04} alt="tool_04" />
            <p>
                Next, I level three slots and get the abilities "Special Charge Up", "Quick Respawn", "Special Charge
                Up". Putting them all in gives me 4 results.
            </p>
            <img src={tool_07} alt="tool_07" />
            <p>
                Now I need to scrub the gear again, level one more slot, get "Special Charge Up" and I put it into the
                search again. After this I find my seed.
            </p>
            <img src={tool_08} alt="tool_08" />
            <h4>Example (Without SplatNet import)</h4>
            <p>
                For this example I use Skalop branded gear. In order to add more slots to the tool, click on the "+"
                button. After leveling all three slots, I get "Ink Recovery Up", "Quick Respawn", and "Ink Recovery Up".
                I enter these in Slot 0, 1, and 2. When you click on <code>Search Seed</code> then it will give you a
                list of many seeds quite fast.
            </p>
            <img src={tool_01} alt="tool_01" />
            <p>
                In order to reduce the number of possible seeds, we need to add more rolls. Here I scrub my gear and
                unlock the next three slots. I get three times "Ink Resistance Up". I put it all in the tool again.
            </p>
            <img src={tool_02} alt="tool_02" />
            <p>
                Here, I still get too many possible seeds, so I continue to level it. But this time the "Refine Seed"
                button is not grayed out. This button allows me to calculate the next searches fast. On my next three
                rolls I get "Special Power Up", "Quick Super Jump". After clicking on "Refine Seed" I get exactly one
                seed instantly.
            </p>
            <img src={tool_03} alt="tool_03" />
            <p>
                Now I end up with the seed <code>0x78f56be9</code> for this specific piece of gear and can now predict
                all future rolls on this specific piece of gear.
            </p>
            <h2>Calculating future results</h2>
            <p>
                Here, simply enter your brand, if you want to use a Drink Ticket or not, enter your seed, and then click
                on <code>Display Results</code>. This will show you your future rolls for this specific configuration.
            </p>
            <img src={tool_06} alt="tool_06" />
            <p>The interface in more detail:</p>
            <ol>
                <li>The gear from your database</li>
                <li>The brand of your gear</li>
                <li>The drink you have active during level up. Note that snail rerolling is NOT affected by drinks</li>
                <li>The current seed of your gear</li>
                <li>The slot you unlock next, starting with slot 0</li>
                <li>The ability you will roll on this slot</li>
                <li>The seed of your gear when you reach this roll</li>
                <li>
                    Additional actions. "Update Seed" will just update the seed in the "Current Seed" box with the seed
                    in "Seed After Roll". The button "Update Seed And Save Gear" will also update the seed in your gear
                    database.
                </li>
            </ol>
            <p>Here is the same seed, but with a drink ticket active:</p>
            <img src={tool_05} alt="tool_05" />
            <p>
                It is advices to keep track of of the new seed for your gear for every level when you use a Drink
                Ticket.
            </p>
        </div>
    )
}

const SeedListingTutorial = props => {
    return (
        <div className={classes.WrapperTop}>
            <h2>About Seed Listing</h2>
            <p>
                In Splatoon 3 nearly everything is controlled by a seed, i.e. the Shell-Out Machine, Murch rewards or
                the Shel-drone, Card packs, etc. The Seed Listing page will display your future rolls and similar after
                you provided a seed.
            </p>
            <h2>FAQ</h2>
            <ul>
                <li>
                    Q: Do I need a hacked switch for this?
                    <br />
                    A: No.
                </li>
                <li>
                    Q: What do I need to get my seed?
                    <br />
                    A: As of now I provide an easy way to get the seed after you imported your gear from SplatNet. After
                    that you only need to provide a few rolls in order to get the seed.
                </li>
                <li>
                    Q: Can I get banned for this?
                    <br />
                    A: No. All you do is to provide some rolls you did in-game and also use their SplatNet app.
                </li>
                <li>
                    Q: Does the seed change between seasons?
                    <br />
                    A: No, the seed stays the same. The results might change when new items get added (i.e. new capsules
                    for shell-out machine or new random titles for the title seed), but there is no need to re-calibrate
                    the seed when the season changes.
                </li>
                <li>
                    Q: My result is inaccurate, what do I do? <br />
                    A: If you pulled a 10x Ability (Bronze) Capsule instead of a Gold or Silver Capsule, then the future
                    results might be inaccurate. Right now there is no way to track your acquired banners/titles, so if
                    you pull a duplicate it gets replaced wit ha different capsule. Usually it will be correct again
                    after 2-3 additional pulls, but if this is not the case please use "Reset Seed" and find your need
                    seed this way. For any other inaccuracy please contact me on Twitter or Discord.
                </li>
            </ul>
            <h2>Importing Data from SplatNet</h2>
            <p>
                It is required that you import your data from SplatNet in order to use this functionality. Follow the
                instructions on the User Settings page for the import step.
            </p>
            <h2>Getting the Seed</h2>
            <p>
                Note: As of now you can only obtain your Shell-Out Machine seed with this method. More seed lists will
                be provided in the future.
            </p>
            <h3>Step 1: Obtaining Data</h3>
            <p>
                As a prerequisite you need to be able to get at least 5 pulls from the Shell-Out machine. The average
                number of pulls to get the seed is 5, worst case is 11. Please make sure to select the correct tab.
                While a splatfest is active and you get capsules with a shell on it, then select the Splatfest tab.
                Otherwise use the normal tab.
            </p>
            <img src={finder_01} alt="Seed Finder" />
            <ol>
                <li>Your pulls in correct order</li>
                <li>Buttons for adding/remove additional pulls</li>
                <li>Start seed search</li>
                <li>Result of seed search</li>
            </ol>
            <p>
                After you have inputted enough pulls, it will find a seed. If you want to save the seed, click "Store
                Seed". Here is an example of a search:
            </p>
            <img src={finder_02} alt="Seed Finder3" />
            <h3>Step 2: See future pulls</h3>
            <p>
                After you have obtained your seed, you will see the following page. Please note that the seed for the
                Shell-Out Machine is four times longer than for the geer seed. To keep it simple the seed is split into
                4 numbers.
            </p>
            <img src={lister_01} alt="listin" />
            <ol>
                <li>Your seeds</li>
                <li>Filter for result types</li>
                <li>Number of rolls you need to do in order to get this reward</li>
                <li>Capsule Color</li>
                <li>
                    Result. If possible I used an image for it. Please note that I cannot predict the banner, title or
                    decoration you get, as they use an external seed. I will add support for them at another point.
                </li>
                <li>Seed after roll</li>
                <li>
                    Additional options. "Update Seed" copies your seed into the current seed box, "Update Seed And Save
                    Gear" also stores your progress internally.
                </li>
            </ol>
        </div>
    )
}

export default Tutorial
